import gql from 'graphql-tag';

export default gql`
  mutation ($course: MongoID!, $subject: MongoID!, $index: Float) {
    createCourseItem(record: { course: $course, subject: $subject, index: $index }) {
      recordId
    }
  }
`;
